import axios from 'axios';

// Create an Axios instance for all API calls
const axiosClient = axios.create({
  baseURL: 'http://localhost:8000', // Base URL for Django backend
  withCredentials: true,            // Send cookies (sessionid, csrftoken) with requests
  headers: {
    'Content-Type': 'application/json', // Default header for JSON payloads
  },
});
// Fetch CSRF token from Django backend
const fetchCsrfToken = async () => {
  try {
    const response = await axios.get('http://localhost:8000/elearning/get-csrf/', {
      withCredentials: true, // Ensure cookies are sent for CSRF validation
    });
      return response.data.csrfToken;
  } catch (error) {
    console.error('[axiosClient] Error fetching CSRF token:', error);
    throw error;
  }
};
// Request interceptor to add CSRF token for unsafe methods
axiosClient.interceptors.request.use(
  async (config) => {
    const method = config.method?.toLowerCase() || '';
    if (['post', 'put', 'patch', 'delete'].includes(method)) {
      try {
               // Fetch CSRF token dynamically
          config.headers['X-CSRFToken'] = await fetchCsrfToken();      // Add token to headers
      } catch (error) {
        console.error('[axiosClient] Failed to add CSRF token:', error);
      }
    }
    return config;
  },
  (error) => {
    console.error('[axiosClient] Request interceptor error:', error);
    return Promise.reject(error);
  }
);
// Response interceptor for logging and error handling
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('[axiosClient] Response error:', error.response?.status, error.response?.data);
    return Promise.reject(error);
  }
);
export default axiosClient;
